import React from "react";
import { Modal } from "antd";
import { ViewProfileImage } from "./viewProfileImage";
import { UploadProfileImage } from "./uploadProfileImage";

export function ProfileImageModal(props) {
  const { visible, onCancel, action, width, height, agentId, url, retrieveUser, title } = props;
  const modalTitle = action === "edit" ? "Update Profile Picture" : "Profile Picture";

  return (
    <Modal visible={visible} title={title || modalTitle} onCancel={onCancel} footer={null}>
      {action === "view" && <ViewProfileImage url={url} width={width} height={height} />}
      {action === "edit" && (
        <UploadProfileImage agentId={agentId} closeModal={onCancel} retrieveUser={retrieveUser} />
      )}
    </Modal>
  );
}
